import { Injectable } from '@angular/core';
import { isEqual } from 'lodash';

@Injectable({
  providedIn: 'root',
})
export class SclUtilAuditService {
  constructor() {}

  // Split string and then return to object array.(used in sc-audit-table)
  getObjectSplit(object, type) {
    let returnObject = object;
    if (type === 'doubleEquals') {
      returnObject = returnObject.split(':==:');
    } else if (type === 'equalWithArrow') {
      returnObject = returnObject.split('=:>');
    }
    return returnObject;
  }
  // Get list of object that has changes/ has an update .(used in sc-audit-table)
  getUpdatedObject(obj, isFieldView) {
    const objectChangesSring = '';
    const objectStrHoldter = [];
    let notInclude = ['systemHeader', '_id', "documentId"] 
    for (const key in obj) { 
        if(!isFieldView && notInclude.includes(key)) continue;
        if (this.getDataType(obj[key]) === 'array' || this.getDataType(obj[key]) === 'object') {
          const objInside1 = obj[key];
          for (const insideKey1 in objInside1) {
            if (this.getDataType(objInside1[insideKey1]) === 'array' || this.getDataType(objInside1[insideKey1]) === 'object') {
              const objInside2 = objInside1[insideKey1];
              for (const insideKey2 in objInside2) {
                if (this.getDataType(objInside2[insideKey2]) === 'array' || this.getDataType(objInside2[insideKey2]) === 'object') {
                  const objInside3 = objInside2[insideKey2];
                  for (const insideKey3 in objInside3) {
                    if (
                      this.getDataType(objInside3[insideKey3]) === 'array' ||
                      this.getDataType(objInside3[insideKey3]) === 'object'
                    ) {
                      // console.log("2: =>", key, insideKey1, insideKey2, insideKey3, +" -> " + JSON.stringify(objInside3[insideKey3]));
                    } else {
                      if (objInside3[insideKey3] === 'unchanged') {
                        break;
                      }
                      objectStrHoldter.push(
                        key + '=>' + insideKey1 + '=>' + insideKey2 + ':==:' + insideKey3 + '=:>' + objInside3[insideKey3]
                      );
                    }
                  }
                } else {
                  if (objInside2[insideKey2] === 'unchanged') {
                    break;
                  }
                  objectStrHoldter.push(key + '=>' + insideKey1 + ':==:' + insideKey2 + '=:>' + objInside2[insideKey2]);
                }
              }
            } else {
              if (objInside1[insideKey1] === 'unchanged') {
                break;
              }
              objectStrHoldter.push(key + ':==:' + insideKey1 + '=:>' + objInside1[insideKey1]);
            }
          }
        } else {
          objectStrHoldter.push(key + '=:>' + obj[key]);
        }
      
    }

    return objectStrHoldter;
  }

  // Split that return data type.(used in sc-audit-table)
  getDataType(data) {
    if (data === undefined || data === null) {
      return 'undefined';
    }
    if (data.constructor === String) {
      return 'string';
    }

    if (data.constructor === Array) {
      return 'array';
    }

    if (data.constructor === Object) {
      return 'object';
    }

    if (data.constructor === Number) {
      return 'number';
    }

    if (data.constructor === Boolean) {
      return 'boolean';
    }

    if (data.constructor === Function) {
      return 'function';
    }

    if (data.constructor === Date) {
      return 'date';
    }

    if (data.constructor === RegExp) {
      return 'regex';
    }

    return 'unknown';
  }
  
 
  // funtion return the difference of two object versions.(used in sc-audit-table)
  getObjectDifference(obj1, obj2) {
    if (
      (this.getDataType(obj1) !== 'array' && this.getDataType(obj1) !== 'object') ||
      (this.getDataType(obj2) !== 'array' && this.getDataType(obj2) !== 'object')
    ) {
      let type1 = '';

      if (
        obj1 === obj2 ||
        (this.getDataType(obj1) === 'date' && this.getDataType(obj2) === 'date' && obj1.getTime() === obj2.getTime())
      ) {
        type1 = 'unchanged';
      } else if (this.getDataType(obj1) === 'undefined') {
        type1 = 'created';
      }
      if (this.getDataType(obj2) === 'undefined') {
        type1 = 'deleted';
      } else if (type1 === '') {
        type1 = 'updated';
      }

      return {
        type: type1,
        data: obj1 === undefined ? obj2 : obj1,
      };
    }
    let diff;
    if (this.getDataType(obj1) === 'array' && this.getDataType(obj2) === 'array') {
      diff = [];
      obj1.sort();
      obj2.sort();
      for (let i1 = 0; i1 < obj2.length; i1++) {
        const type2 = obj1.some((item) => isEqual(item, obj2[i1])) ? 'unchanged' : 'created';
        if (type2 === 'created' && (this.getDataType(obj2[i1]) === 'array' || this.getDataType(obj2[i1]) === 'object')) {
          diff.push(this.getObjectDifference(obj1[i1], obj2[i1]));
          continue;
        }
        diff.push({
          type: type2,
          data: obj2[i1],
        });
      }

      for (let i2 = 0; i2 < obj1.length; i2++) {
        if (!obj2.some((item) => isEqual(item, obj1[i2]))) {
          diff.push({
            type: 'deleted',
            data: obj1[i2],
          });
        }
      }
    } else {
      diff = {};
      let key = Object.keys(obj1);
      for (let i3 = 0; i3 < key.length; i3++) {
        let value2;
        if (this.getDataType(obj2[key[i3]]) !== 'undefined') {
          value2 = obj2[key[i3]];
        }

        diff[key[i3]] = this.getObjectDifference(obj1[key[i3]], value2);
      }

      key = Object.keys(obj2);
      for (let i = 0; i < key.length; i++) {
        if (this.getDataType(diff[key[i]]) !== 'undefined') {
          continue;
        }

        diff[key[i]] = this.getObjectDifference(undefined, obj2[key[i]]);
      }
    }

    return diff;
  }
  // function to get list of changes in all versions.(used in sc-audit-table)
  getObjectVersionData(
    objectDocVersionData: any,
    getUserFn,
    formatTimeFn,
    getLabelsFromTemplateFn,
    resultUserDataObj,
    currentTemplateComponentsObj,
    isFieldView,
    isHasTargetTableComponent?
  ) {
    const dataResult: any = objectDocVersionData;
    const objectDataSet = [];
    let dataChangesObj = [];
    const objectRecordChanges = [];
    const dataResultLength = dataResult.length - 1;

    for (let index = 0; index < dataResult.length; index++) {
      const insideDataSetObject = [];
      const stringType = '';
      const stringKey = '';
      const inc = 0;
      let varWho = '';
      let varWhen = '';
      let varInitialValue = '';
      let varNewValue = '';
      const objectVersion1 = dataResult[index];
      const nextIndex = index + 1;
      const objectVersion2 = dataResult[nextIndex];
      if (index === dataResultLength) {
        const createByEmailName1 = getUserFn(objectVersion1.systemHeader.createdBy, resultUserDataObj);
        varWho =
          createByEmailName1 && createByEmailName1.systemHeader
            ? createByEmailName1.systemHeader.summaryName
            : objectVersion1.systemHeader.createdBy;
        varWhen = isHasTargetTableComponent
          ? objectVersion1.systemHeader.createdDate
          : formatTimeFn(objectVersion1.systemHeader.createdDate);
        varInitialValue = 'Created';
        varNewValue = 'Created';
        insideDataSetObject.push(index + 1);
        insideDataSetObject.push(varWho);
        insideDataSetObject.push(varWhen);
        insideDataSetObject.push(varInitialValue);
        insideDataSetObject.push(varNewValue);
       
        // get the added fields
        
        // let keys = Object.keys(objectVersion1)
        // keys.forEach((key) => {
        //     let label = key;
        //     let keyNotNeedingLabel = ["systemHeader", "documentId", "_id"]
        //     if(!keyNotNeedingLabel.includes(key)){
        //       label = getLabelsFromTemplateFn(key, currentTemplateComponentsObj)
        //     } 
            
        //     if(key != label ){
        //       objectVersion1[label] = objectVersion1[key]
        //       delete objectVersion1[key]
        //     }
        
        // })
 
        
        insideDataSetObject.push(objectVersion1);
        // insideDataSetObject.push(objectVersion1.systemHeader.systemType);
      } else {
        // compare two versionId incremented by 1 versionIndex
        dataChangesObj = this.getObjectDifference(objectVersion2, objectVersion1);
        let objectUpdated = this.getUpdatedObject(dataChangesObj, isFieldView);
        // console.log(index, objectVersion1, objectVersion2, dataChangesObj,objectUpdated);
        // console.log(objectUpdated.length,objectUpdated,dataChangesObj);
        objectRecordChanges.push(objectUpdated);
        const newObjectUpdated = [];
        for (const keyObjUpdated1 in objectUpdated) {
          // Filter objectUpdated list, return string type and not string data
          if (!(objectUpdated[keyObjUpdated1].toString().indexOf('data=') >= 0)) {
            newObjectUpdated.push(objectUpdated[keyObjUpdated1]);
          }
        }
        objectUpdated = newObjectUpdated;
        // console.log(objectRecordChanges,objectUpdated.length,objectUpdated,dataChangesObj);
        let strNewValue = '';
        let strOldValue = '';
        let thisTypeValue;
        for (const keyObjUpdated in objectUpdated) {
          if (objectUpdated.length > 0) {
            const keyNames = objectUpdated[keyObjUpdated].split(':==:')[0].split('=>');
            // console.log(keyNames);
            strOldValue = strOldValue.trim() === '' ? '' : strOldValue + '\n';
            strNewValue = strNewValue.trim() === '' ? '' : strNewValue + '\n';
            if (keyNames.length === 1) {
              thisTypeValue = dataChangesObj[keyNames[0]].type;
              if (thisTypeValue === 'created') {
                strOldValue =
                  strOldValue + getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) + ':No initial value';
                strNewValue =
                  strNewValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  ':' +
                  JSON.stringify(dataChangesObj[keyNames[0]].data) +
                  ' (New)';
              } else if (thisTypeValue === 'deleted') {
                strOldValue =
                  strOldValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  ':' +
                  JSON.stringify(objectVersion2[keyNames[0]]);
                strNewValue = strNewValue + getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) + ' (Deleted)';
              } else if (thisTypeValue === 'updated') {
                strOldValue =
                  strOldValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  ':' +
                  JSON.stringify(objectVersion2[keyNames[0]]);
                strNewValue =
                  strNewValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  ':' +
                  JSON.stringify(objectVersion1[keyNames[0]]) +
                  ' (Updated)';
              }
            } else if (keyNames.length === 2) {
              thisTypeValue = dataChangesObj[keyNames[0]][keyNames[1]].type;
              if (thisTypeValue === 'created') {
                strOldValue =
                  strOldValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  '.' +
                  keyNames[1] +
                  ':No initial value';
                strNewValue =
                  strNewValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  '.' +
                  keyNames[1] +
                  ':' +
                  JSON.stringify(objectVersion1[keyNames[0]][keyNames[1]]) +
                  ' (New)';
              } else if (thisTypeValue === 'deleted') {
                strOldValue =
                  strOldValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  '.' +
                  keyNames[1] +
                  ':' +
                  JSON.stringify(objectVersion2[keyNames[0]][keyNames[1]]);
                strNewValue =
                  strNewValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  '.' +
                  keyNames[1] +
                  ' (Deleted)';
              } else if (thisTypeValue === 'updated') {
                strOldValue =
                  strOldValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  '.' +
                  keyNames[1] +
                  ':' +
                  JSON.stringify(objectVersion2[keyNames[0]][keyNames[1]]);
                strNewValue =
                  strNewValue +
                  getLabelsFromTemplateFn(keyNames[0], currentTemplateComponentsObj) +
                  '.' +
                  keyNames[1] +
                  ':' +
                  JSON.stringify(objectVersion1[keyNames[0]][keyNames[1]]) +
                  ' (Updated)';
              }

            } else if (keyNames.length === 3) {
              thisTypeValue = dataChangesObj[keyNames[0]][keyNames[1]][keyNames[2]].type;
              if (thisTypeValue === 'created') {
                strOldValue = strOldValue + keyNames[0] + '.' + keyNames[1] + '.' + keyNames[2] + ':No initial value';
                strNewValue =
                  strNewValue +
                  keyNames[0] +
                  '.' +
                  keyNames[1] +
                  '.' +
                  keyNames[2] +
                  ':' +
                  JSON.stringify(objectVersion1[keyNames[0]][keyNames[1]][keyNames[2]]) +
                  ' (New)';
              } else if (thisTypeValue === 'deleted') {
                strOldValue =
                  strOldValue +
                  keyNames[0] +
                  '.' +
                  keyNames[1] +
                  '.' +
                  keyNames[2] +
                  ':' +
                  JSON.stringify(objectVersion2[keyNames[0]][keyNames[1]][keyNames[2]]);
                strNewValue = strNewValue + keyNames[0] + '.' + keyNames[1] + '.' + keyNames[2] + ' (Deleted)';
              } else if (thisTypeValue === 'updated') {
                strOldValue =
                  strOldValue +
                  keyNames[0] +
                  '.' +
                  keyNames[1] +
                  '.' +
                  keyNames[2] +
                  ':' +
                  JSON.stringify(objectVersion2[keyNames[0]][keyNames[1]][keyNames[2]]);
                strNewValue =
                  strNewValue +
                  keyNames[0] +
                  '.' +
                  keyNames[1] +
                  '.' +
                  keyNames[2] +
                  ':' +
                  JSON.stringify(objectVersion1[keyNames[0]][keyNames[1]][keyNames[2]]) +
                  ' (Updated)';
              }
            }
          }
        }

        const createByEmailName1 = getUserFn(objectVersion1.systemHeader.createdBy, resultUserDataObj);
        varWho =
          createByEmailName1 && createByEmailName1.systemHeader
            ? createByEmailName1.systemHeader.summaryName
            : objectVersion1.systemHeader.createdBy;
        varWhen = isHasTargetTableComponent
          ? objectVersion1.systemHeader.createdDate
          : formatTimeFn(objectVersion1.systemHeader.createdDate);
        varInitialValue = strOldValue;
        varNewValue = strNewValue;

        insideDataSetObject.push(index + 1);
        insideDataSetObject.push(varWho);
        insideDataSetObject.push(varWhen);
        insideDataSetObject.push(varInitialValue + '\n' + 'lastUpdated:"' + objectVersion2.systemHeader.createdDate + '"');
        insideDataSetObject.push(varNewValue + '\n' + 'lastUpdated:"' + objectVersion1.systemHeader.createdDate + '"');

        insideDataSetObject.push(objectVersion1);
        // insideDataSetObject.push(objectVersion1.systemHeader.systemType);
      }

      objectDataSet.push(insideDataSetObject);
    }
    return objectDataSet;
  }
}
